import React from "react";
import { Navigate } from "react-router-dom";
import PermissionGuard from "../auth/PermissionGuard";
import ProtectedRoute from "../auth/ProtectedRoute";

/**
 * 移动全屏受保护布局：给地面人员在手机上直接打开使用的页面用（如过站检查单）。
 *
 * 与运营大屏的 FullScreenProtectedLayout 的区别：那个是 position:fixed + overflow:hidden，
 * 给固定不滚动的大屏用；这里内容要纵向滚动录入，所以走正常文档流、可滚动、内容铺满视口宽度，
 * 且不挂后台侧边栏（避免窄屏被侧边栏挤出内容）。登录与权限校验照常保留。
 */
const MobileProtectedLayout = ({ children, permission }) => {
    return (
        <ProtectedRoute>
            <PermissionGuard
                permission={permission}
                requireAll={Array.isArray(permission) ? false : true}
                fallback={<Navigate to="/" replace />}
            >
                <div style={{ minHeight: "100vh", width: "100%", overflowX: "hidden", background: "#f5f5f5" }}>{children}</div>
            </PermissionGuard>
        </ProtectedRoute>
    );
};

export default MobileProtectedLayout;
